import React, { useState, useRef } from "react";
// Accordion styles are defined in weekly-war-map.css

export const CollapsibleCard = ({
  title,
  children,
  defaultOpen = false,
  defaultBadge = null,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // The CSS must be defined separately (see Step 2)
  return (
    <div className="accordion-container">
      {/* Header/Title Row */}
      <div className="accordion-header" onClick={toggleAccordion}>
        {/* Title */}
        <span className="body-b2" style={{ color: "#C8CED3" }}>
          {title}
        </span>

        <img
          // className={`accordion-icon ${isOpen ? "open" : ""}`}
          src={
            isOpen
              ? "/icons/accordion-arrow-up.svg"
              : "/icons/accordion-arrow-down.svg"
          }
          alt="arrow-icon"
        />
      </div>

      {!isOpen && defaultBadge && <div className="mt-2">{defaultBadge}</div>}

      {/* Horizontal Rule (HR) */}
      {isOpen && <hr className="accordion-divider" />}

      {/* Content Area */}
      {/* Use style height and ref for smooth transition (better than conditional rendering for animation) */}
      <div
        ref={contentRef}
        className="accordion-content-wrapper"
        style={{
          maxHeight: isOpen ? "800px" : "0", // Max height when open
          opacity: isOpen ? "1" : "0", // Fading effect
        }}
      >
        {/* The children passed (Card, etc.) with the required vertical margin */}
        <div
          className="accordion-content-inner"
          style={{
            height: isOpen ? "400px" : "auto", // Fixed height when open to enable scrolling
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
